const localisations = {
    fileErrorPane: {
        title: "File Errors",
        description:
            "The following file level errors were found whilst processing the stock transfer file.",
        table: {
            columns: {
                type: {
                    headerName: "Error Type",
                    description: "",
                },
                detail: {
                    headerName: "Error",
                    description: "",
                },
            },
        },
    },
    itemLevelErrorPane: {
        title: "Item Errors",
        description: "The following item level errors were found whilst processing the stock transfer file.",
        table: {
            columns: {
                reference: {
                    headerName: "Reference",
                    description: "",
                },
                type: {
                    headerName: "Error Type",
                    description: "",
                },
                detail: {
                    headerName: "Error",
                    description: "",
                },
            },
        },
    },
    filePreCheckValidPane: {
        title: "Pre-check Passed",
        description: "Please review the planned actions and click NEXT to proceed.",
    },
    filePreCheckInvalidPane: {
        title: "Pre-check Failed",
        description: "Please review the errors below and correct the issues before re-uploading the file.",
    },
    fileImportValidPane: {
        title: "File processed successfully",
        description: "The file was successfully processed.",
    },
    fileImportInvalidPane: {
        title: "File processing failed",
        description: "Errors were encountered while processing the file. Please contact App Support, quoting the reference:",
    },
    fileHttpErrorPane: {
        title: "Server Issues",
        description: "The import failed due to an unexpected issue on, or connecting to, the server.",
    },
    fileNameConflictDialog: {
        titleText: "Resubmit file?",
        contentText: "A file with name '{FILENAME}' was most recently submitted on date '{LASTIMPORTDATE}'. Are you sure you wish to submit a file with the same name?",
        cancelButtonText: "Cancel",
        confirmButtonText: "Confirm",
        errorGettingDateText: "Error Getting Date"
    },
    preCheckHeadings:{
        itemActionsAndErrorsHeading: "Import Results",
        fileLevelErrorsHeading:"File Errors",
        resultTableRow: "Row",
        resultTableErrors: "Failures",
        resultTableActions: "Actions planned",
        resultTableActionsTaken: "Actions taken",
        resultTableErrorsAndActions: "Actions and failures"
    },
    importWarning:{
        warningText:"Please wait as this process may take a few minutes to complete.",
    }
};

export default localisations;
